import React from "react";
import PropTypes from "prop-types";
import ClearIcon from "@mui/icons-material/Clear";
import { EDIT_COLUMNS } from "../../../../config/deviceColumnsConfig";

const EditDeviceRow = ({
  device,
  index,
  selectedDevice,
  onRowClick,
  handlers,
}) => {
  const isSelected =
    selectedDevice && selectedDevice.deviceId === device.deviceId;
  return (
    <tr
      onClick={() => onRowClick(device)}
      className={`border-t cursor-pointer ${
        isSelected ? "bg-cyan-100" : "bg-transparent"
      } ${!isSelected ? "hover:bg-cyan-50 hover:shadow-lg" : ""}`}
    >
      <td className="px-1 py-1 border border-white bg-white text-center">
        <button
          onClick={() => handlers.removeDevice(device.deviceId)}
          className="text-gray-500 hover:text-red-500 transition duration-150"
          aria-label="Remove Device"
        >
          <ClearIcon fontSize="small" />
        </button>
      </td>
      {EDIT_COLUMNS.map((col) => (
        <td key={col.key} className="px-1 py-1 border">
          {col.type === "select" ? (
            <select
              name={col.key}
              value={device[col.key]}
              onChange={(e) =>
                handlers.handleDeviceFieldChange(
                  device.deviceId,
                  col.key,
                  e.target.value
                )
              }
              className="w-full border-0 outline-none bg-inherit"
            >
              {col.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          ) : (
            <input
              type={col.type}
              name={col.key}
              value={device[col.key]}
              onChange={(e) =>
                handlers.handleDeviceFieldChange(
                  device.deviceId,
                  col.key,
                  e.target.value
                )
              }
              className="w-full border-0 outline-none bg-inherit"
            />
          )}
        </td>
      ))}
    </tr>
  );
};

EditDeviceRow.propTypes = {
  device: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectedDevice: PropTypes.object,
  onRowClick: PropTypes.func.isRequired,
  handlers: PropTypes.shape({
    removeDevice: PropTypes.func.isRequired,
    handleDeviceFieldChange: PropTypes.func.isRequired,
  }).isRequired,
};

export default EditDeviceRow;
